import { Events } from '@cookspace-shared-contracts/core';

import { baseApi } from '@/api/baseApi';
import { parseWithSchema } from '@/lib/safeParse';

/**
 * RTK Query endpoints для admin-backend /events/*.
 * Read-only режим: list (всех статусов) и get details.
 * admin-backend на порту 5002 без префикса /admin.
 */
export const eventsApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        listEvents: build.query<
            Events.GetEventsResponse,
            Events.GetEventsRequest | void
        >({
            query: (params) => {
                const search: Record<string, string> = {};
                if (params?.search) {
                    search.search = params.search;
                }
                if (params?.categoryId) {
                    search.categoryId = params.categoryId;
                }
                if (params?.status) {
                    search.status = params.status;
                }
                if (params?.isPremium !== undefined) {
                    search.isPremium = params.isPremium ? 'true' : 'false';
                }
                if (params?.isFree !== undefined) {
                    search.isFree = params.isFree ? 'true' : 'false';
                }
                if (params?.city) {
                    search.city = params.city;
                }
                if (params?.isUserContent !== undefined) {
                    search.isUserContent = params.isUserContent ? 'true' : 'false';
                }
                if (params?.authorId) {
                    search.authorId = params.authorId;
                }
                if (params?.scheduledAfter) {
                    search.scheduledAfter = params.scheduledAfter;
                }
                if (params?.scheduledBefore) {
                    search.scheduledBefore = params.scheduledBefore;
                }
                if (params?.limit !== undefined) {
                    search.limit = String(params.limit);
                }
                if (params?.offset !== undefined) {
                    search.offset = String(params.offset);
                }
                return {
                    url: '/events',
                    method: 'GET',
                    params: search
                };
            },
            transformResponse: (raw: unknown): Events.GetEventsResponse =>
                parseWithSchema(Events.GetEventsResponseSchema, raw),
            providesTags: (result) =>
                result
                    ? [
                        ...result.items.map((e) => ({
                            type: 'Event' as const,
                            id: e.id
                        })),
                        { type: 'Event' as const, id: 'LIST' }
                    ]
                    : [{ type: 'Event' as const, id: 'LIST' }]
        }),

        getEvent: build.query<Events.GetEventResponse, { id: string }>({
            query: ({ id }) => ({
                url: `/events/${id}`,
                method: 'GET'
            }),
            transformResponse: (raw: unknown): Events.GetEventResponse =>
                parseWithSchema(Events.GetEventResponseSchema, raw),
            providesTags: (_result, _error, arg) => [{ type: 'Event', id: arg.id }]
        })
    })
});

export const { useListEventsQuery, useGetEventQuery } = eventsApi;
